import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services/authService';

const LoginPage = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const result = await authService.login(email, password);
      
      // Route based on role
      if (result.user.role === 'LenderAdmin') {
        navigate('/lender/brokers');
      } else if (result.user.role === 'BrokerAdmin') {
        navigate('/broker/dashboard');
      } else if (result.user.role === 'BrokerUser') {
        navigate('/broker/pipeline');
      }
    } catch (err) {
      setError(err.message || 'Login failed. Please check your credentials.');
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleLogin = async () => {
    setError('');
    setLoading(true);

    try {
      const result = await authService.loginWithGoogle();
      
      if (result.user.role === 'LenderAdmin') {
        navigate('/lender/brokers');
      } else if (result.user.role === 'BrokerAdmin') {
        navigate('/broker/dashboard');
      } else if (result.user.role === 'BrokerUser') {
        navigate('/broker/pipeline');
      }
    } catch (err) {
      setError(err.message || 'Google login failed.');
    } finally {
      setLoading(false);
    }
  };

  const handleMicrosoftLogin = async () => {
    setError('');
    setLoading(true);

    try {
      const result = await authService.loginWithMicrosoft();
      
      if (result.user.role === 'LenderAdmin') {
        navigate('/lender/brokers');
      } else if (result.user.role === 'BrokerAdmin') {
        navigate('/broker/dashboard');
      } else if (result.user.role === 'BrokerUser') {
        navigate('/broker/pipeline');
      }
    } catch (err) {
      setError(err.message || 'Microsoft login failed.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page page-center">
      <div className="container container-tight py-4">
        <div className="text-center mb-4">
          <h1 className="navbar-brand navbar-brand-autodark">
            <span className="text-primary">UFF</span> Pro Portal
          </h1>
        </div>
        
        <div className="card card-md">
          <div className="card-body">
            <h2 className="h2 text-center mb-4">Sign in to your account</h2>
            
            {error && (
              <div className="alert alert-danger" role="alert">
                <div className="d-flex">
                  <div>
                    <i className="ti ti-alert-circle me-2"></i>
                  </div>
                  <div>{error}</div>
                </div>
              </div>
            )}
            
            <form onSubmit={handleSubmit} autoComplete="off">
              <div className="mb-3">
                <label className="form-label">Email address</label>
                <input
                  type="email"
                  className="form-control"
                  placeholder="your@email.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  disabled={loading}
                  autoComplete="off"
                />
              </div>
              
              <div className="mb-2">
                <label className="form-label">Password</label>
                <input
                  type="password"
                  className="form-control"
                  placeholder="Your password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  disabled={loading}
                  autoComplete="off"
                />
              </div>
              
              <div className="form-footer">
                <button type="submit" className="btn btn-primary w-100" disabled={loading}>
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                      Signing in...
                    </>
                  ) : (
                    'Sign in'
                  )}
                </button>
              </div>
            </form>
            
            <div className="hr-text">or</div>
            
            <div className="row">
              <div className="col">
                <button
                  className="btn w-100"
                  onClick={handleGoogleLogin}
                  disabled={loading}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-brand-google" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M17.788 5.108a9 9 0 1 0 3.212 6.892h-8"></path>
                  </svg>
                  Sign in with Google
                </button>
              </div>
              <div className="col">
                <button
                  className="btn w-100"
                  onClick={handleMicrosoftLogin}
                  disabled={loading}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-brand-windows" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M17.8 20l-12 -1.5c-1 -.1 -1.8 -.9 -1.8 -1.9v-9.2c0 -1 .8 -1.8 1.8 -1.9l12 -1.5c1.2 -.1 2.2 .8 2.2 1.9v12.1c0 1.2 -1.1 2.1 -2.2 1.9z"></path>
                    <path d="M12 5l0 14"></path>
                    <path d="M4 12l16 0"></path>
                  </svg>
                  Sign in with Microsoft
                </button>
              </div>
            </div>
          </div>
        </div>
        
        <div className="text-center text-secondary mt-3">
          <small>
            Users are created by administrators. No self-signup available.
          </small>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
